app.service('ClassementClientApiService', [
    '$stateParams', 'crudService', '$window', 'contratService',
    function ($stateParams, crudService, $window, contratService) {

        this.baseUri = '/classements';

        this.getClassements = function () {
            return crudService.post(
                contratService.urlFeature('messages_qualeveille', 'get-classements-by-contract'),
                {'contractId': contratService.getContratId()}
            );
        };

        this.getUri = function (str, data) {
            str = str || '';
            data = data || {};

            if (Object.keys(data).length) {
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        str = str.replace(':' + key, data[key]);
                    }
                }
            }

            return this.baseUri + str;
        };

        this._setUrlParams = function (url, searchParams) {
            if ($window.URLSearchParams && angular.isDefined(searchParams) && Object.keys(searchParams).length) {
                var urlParams = new $window.URLSearchParams($window.location.search);

                for (var key in searchParams) {
                    if (searchParams.hasOwnProperty(key) && searchParams[key] !== null) {
                        if (!urlParams.has(key)) {
                            urlParams.append(key, searchParams[key])
                        }
                    }
                }

                if (urlParams.toString().length) {
                    url += '?' + urlParams.toString();
                }
            }

            return url;
        };

    }]);
